import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-back',
    templateUrl: './question-damage-image-back.component.html',
    styleUrls: ['./question-damage-image-back.component.scss'],
    standalone: false
})
export class QuestionDamageImageBackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
